export default __webpack_public_path__ + "images/42dcd1ee5a69e07daebcb1d212d7b1eb.svg";